import React, { useState } from 'react';
import { updatePrioridadTarea } from '../services/tareasService';
import { getDetalleByParametroId } from '../services/Admin/detalleParametroService';
import './styles/components.css';

const PrioridadButton = ({ tareaId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [opciones, setOpciones] = useState([]);
  const [selected, setSelected] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleOpenModal = async () => {
    setIsModalOpen(true);
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const data = await getDetalleByParametroId(3);
      setOpciones(data);
    } catch (e) {
      setError('Error al cargar prioridades');
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelected('');
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selected) {
      setError('Seleccione una prioridad');
      return;
    }
    setLoading(true);
    const resp = await updatePrioridadTarea(tareaId, selected);
    if (resp.success) {
      setSuccess('Prioridad actualizada');
      setTimeout(() => {
        handleCloseModal();
      }, 1000);
    } else {
      setError(resp.message);
    }
    setLoading(false);
  };

  return (
    <>
      <button className="priority-btn" onClick={handleOpenModal} style={{ fontSize: '14px' }}>
        Cambiar prioridad
      </button>
      {isModalOpen && (
        <div className="modal-permisos-backdrop">
          <div className="modal-permisos-container" style={{ minWidth: 350, maxWidth: 400 }}>
            <div className="modal-permisos-header">
              <h2 className="modal-permisos-title">Cambiar Prioridad</h2>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-permisos-body">
                {loading && <p>Cargando...</p>}
                {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
                {success && <div style={{ color: 'green', marginTop: '8px' }}>{success}</div>}
                {!loading && opciones.length > 0 && (
                  <div className="form-group">
                    <label htmlFor="prioridad">Prioridad:</label>
                    <select
                      id="prioridad"
                      value={selected}
                      onChange={e => setSelected(e.target.value)}
                      style={{ width: '100%', padding: '8px', marginTop: '8px', borderRadius: '4px', border: '1px solid #e0e0e0' }}
                    >
                      <option value="">Seleccione una prioridad</option>
                      {opciones.map(opt => (
                        <option key={opt.id_detaparametro} value={opt.id_detaparametro}>{opt.nombre}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              <div className="modal-permisos-actions">
                <button type="button" onClick={handleCloseModal} className="modal-permisos-btn cancelar">
                  Cancelar
                </button>
                <button type="submit" className="priority-btn" disabled={loading}>
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default PrioridadButton; 